module.exports = __webpack_public_path__ + "img/ibm.a875db7b.png";